import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ErrorHandlerService {
    constructor() {}

    public handleError(error: HttpErrorResponse): Observable<never> {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
                `Backend returned code ${error.status}, ` +
                    `body was: ${JSON.stringify(error.error)}`,
            );
        }
        let errorMessage;
        if (error.error.error && error.error.error.message) {
            errorMessage = error.error.error.message;
        } else {
            errorMessage =
                'There were some error(s). Please check your internet connection or try again later.';
        }

        // return an ErrorObservable with a user-facing error message
        return throwError(errorMessage);
    }
}
